import { defineModel } from "../define-model";

export type ContentPlan = {
	id: string;
	workspaceId: string;
	projectId: string;
	strategyId: string | null;
	title: string;
	status: "draft" | "active" | "completed" | "archived";
	summary: string;
	periodStart: string | null;
	periodEnd: string | null;
	authorType: "user" | "assistant" | "system";
	createdById: string | null;
	archivedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		contentPlan: ContentPlan;
	}
}

export const model = defineModel({
	name: "contentPlan",
	load: "eager",
	indexes: ["projectId"],
	defaults: ({ userId, workspaceId, now }) => ({
		workspaceId,
		strategyId: null,
		status: "draft" as const,
		summary: "",
		periodStart: null,
		periodEnd: null,
		authorType: "user" as const,
		createdById: userId,
		archivedAt: null,
		createdAt: now,
		updatedAt: now,
	}),
	sort: (a, b) => (b.periodStart ?? b.createdAt).localeCompare(a.periodStart ?? a.createdAt),
});
